// extracted by mini-css-extract-plugin
export default {"buttonsWrapper":"navbar_buttonsWrapper__6KJsS","onFooter":"navbar_onFooter__7x2fu","navButtonLikeWrap":"navbar_navButtonLikeWrap__hLtVQ"};